import { render, staticRenderFns } from "./standPrepare.vue?vue&type=template&id=c898cb96&scoped=true&"
import script from "./standPrepare.vue?vue&type=script&lang=js&"
export * from "./standPrepare.vue?vue&type=script&lang=js&"
import style0 from "./standPrepare.vue?vue&type=style&index=0&id=c898cb96&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c898cb96",
  null
  
)

export default component.exports